var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 62,
    viewBox: "0 0 139 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-11.3%",
    y: "-11.1%",
    width: "122.5%",
    height: "122.1%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.782 6.74c0 3.93 2.857 6.867 6.668 6.867 3.718 0 6.653-2.975 6.653-6.79 0-3.79-2.915-6.767-6.653-6.767-3.682 0-6.668 2.994-6.668 6.69z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.876,
    width: 139,
    height: 62,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.302 24.077c0-.228-.146-.354-.416-.354h-.355v1.149h.261v-.447l.308.447h.329l-.37-.475a.313.313 0 0 0 .243-.32zm-.46.155h-.05v-.296h.053c.129 0 .195.047.195.145 0 .1-.07.15-.199.15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.938 23.292c-.534 0-.96.446-.96 1.003 0 .555.429 1.002.96 1.002.524 0 .95-.452.95-1.002s-.426-1.003-.95-1.003zm0 1.824c-.427 0-.771-.364-.771-.819 0-.459.342-.823.77-.823.417 0 .758.37.758.823 0 .45-.341.819-.758.819z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.58 26.95c0-2.44-1.61-3.844-4.425-3.844h-3.62v13.021h2.44v-5.233h.32l3.373 5.233h3.002l-3.942-5.486c1.842-.39 2.853-1.698 2.853-3.691zm-4.896 2.148h-.71v-3.944h.75c1.521 0 2.348.666 2.348 1.932 0 1.308-.827 2.012-2.388 2.012zM90.004 36.127h6.92v-2.205h-4.481v-3.517h4.31v-2.203h-4.31v-2.89h4.481v-2.206h-6.92v13.021M82.875 31.853l-3.34-8.747h-2.663l5.31 13.355h1.312l5.402-13.355h-2.644l-3.377 8.747",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.252 22.813)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#F48027",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.447 29.623c0 3.83 2.89 6.797 6.603 6.797 1.051 0 1.95-.214 3.059-.761v-2.987c-.978 1.016-1.84 1.423-2.948 1.423-2.456 0-4.201-1.855-4.201-4.492 0-2.496 1.8-4.47 4.09-4.47 1.161 0 2.043.432 3.059 1.465v-2.987c-1.069-.566-1.953-.798-3.002-.798-3.696 0-6.66 3.027-6.66 6.81M49.08 28.1c-1.466-.563-1.895-.936-1.895-1.638 0-.819.765-1.444 1.819-1.444.73 0 1.33.313 1.97 1.052l1.273-1.734c-1.05-.96-2.306-1.446-3.676-1.446-2.211 0-3.9 1.6-3.9 3.728 0 1.798.787 2.715 3.075 3.573.957.35 1.444.585 1.688.742.488.334.733.8.733 1.346 0 1.057-.807 1.836-1.897 1.836-1.163 0-2.1-.603-2.662-1.736l-1.573 1.584c1.123 1.716 2.473 2.478 4.331 2.478 2.532 0 4.313-1.76 4.313-4.276 0-2.07-.823-3.008-3.6-4.065M40.676 23.106h2.438v13.021h-2.438zM32.836 23.106h-3.584v13.021h3.567c1.892 0 3.261-.468 4.462-1.5 1.424-1.234 2.269-3.09 2.269-5.004 0-3.844-2.76-6.517-6.714-6.517zm2.853 9.78c-.771.724-1.764 1.036-3.34 1.036h-.657v-8.61h.656c1.577 0 2.531.292 3.341 1.052.844.782 1.346 1.991 1.346 3.24 0 1.252-.502 2.504-1.346 3.282z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 33v24.971a3.998 3.998 0 0 1-4 4.005H59C93.016 55.047 117.583 45.598 139 33z",
    fill: "#F58220"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.93fee6d3.svg";
export { ForwardRef as ReactComponent };